export default __webpack_public_path__ + "img/beneficios-bg-card-1.8b0bfc9b.png";